import React from "react"
import Layout from "../components/layout"
import Login from "../components/login-ext"

const LoginPage = () => (
    <Layout>
            <Login path="/login/" />
    </Layout>
)
export default LoginPage